import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material';
import { getColor } from '../../../constants/colors';
import { SIZES } from '../../../constants/sizes';
import {
  fontStyle,
  textDecoration,
  textTransform,
} from '../../../utils/text.utils';

export interface TextProps extends Omit<TypographyProps, 'textTransform'> {
  size?: keyof typeof SIZES;
  color?: string;
  weight?: number;
  fontStyle?: string;
  italic?: boolean;
  underline?: boolean;
  textTransform?: boolean;
}

export const StyledText = styled(Typography)<TextProps>`
  margin: 0;
  cursor: default;
  font-size: ${({ size }) => SIZES[size || 'small']};
  color: ${({ color }) => getColor(color || 'shark')};
  text-align: ${({ align }) => align || 'start'};
  font-weight: ${({ weight }) => weight || 'normal'};
  font-style: ${fontStyle};
  text-transform: ${textTransform};
  text-decoration: ${textDecoration};
`;
